export default {
  email: 'Invalid email address. Please try again',
  phone: 'Invalid phone number. Please try again',
  required: 'This field is required',
  unique: '{{value}} not unique',
  compareTwoPasswords: "These passwords don\u2019t match. Please try again.",
  password: 'The password must be 8 characters and contain at least 1 uppercase letter, 1 lowercase letter, 1 digit and 1 special character from !?@#$%^&*()_-',
  'Not Supplied': 'Not Supplied'
};